import { render, staticRenderFns } from "./FaxForm.vue?vue&type=template&id=545fd64e&scoped=true"
import script from "./FaxForm.vue?vue&type=script&lang=js"
export * from "./FaxForm.vue?vue&type=script&lang=js"
import style0 from "./FaxForm.vue?vue&type=style&index=0&id=545fd64e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545fd64e",
  null
  
)

export default component.exports